/**
 * HUSTLEPACE home interactions (xexymix-style motion)
 *  1) Horizontal scroller arrows (hover to show, smooth one-screen scroll)
 *  2) Scroll reveal (IntersectionObserver, fade-up, once)
 *  3) Floating TOP button (appears after 300px, smooth scroll to top)
 *  4) Lazy image fade-in
 *  5) Ranking tab filter (ALL / model)
 * Loaded with defer on every page via layout/theme.liquid.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── 1. Horizontal scroller arrows ─── */
  var SCROLLER_SELECTORS = [
    '.hp-xm-shorts__row',
    '.hp-xm-ig__grid',
    '.hp2-chips',
    '.hp2-review-grid',
    '.hp-bp-lineup__grid'
  ];

  function initScroller(row) {
    if (row.closest('.hp-scroller')) return;
    var wrap = document.createElement('div');
    wrap.className = 'hp-scroller';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hp-scroller__arrow hp-scroller__arrow--prev';
    prev.setAttribute('aria-label', '上一個');
    prev.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hp-scroller__arrow hp-scroller__arrow--next';
    next.setAttribute('aria-label', '下一個');
    next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function update() {
      var overflow = row.scrollWidth > row.clientWidth + 4;
      wrap.classList.toggle('hp-scroller--nooverflow', !overflow);
      prev.disabled = row.scrollLeft <= 1;
      next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
    }
    function step(dir) {
      row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  SCROLLER_SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(initScroller);
  });

  /* ─── 2. Scroll reveal (fade-up, once) ─── */
  var REVEAL_SELECTORS = [
    '.hp-xm-quick',
    '.hp2-chips',
    '.hp-bp-lineup',
    '.hp-bp-story',
    '.hp2-video',
    '.hp-xm-shorts',
    '.hp-xm-ig',
    '.hp2-brand-products',
    '.hp2-rising',
    '.hp2-reviews',
    '.hp-xm-campaign',
    '.hp-xm-one-plus-one',
    '.hp-xm-story',
    '.hp-xm-photorev',
    '.hp-xm-benefits'
  ];

  var revealEls = [];
  REVEAL_SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.classList.add('hp-reveal');
      revealEls.push(el);
    });
  });

  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* ─── 3. Floating TOP button ─── */
  var topBtn = document.createElement('button');
  topBtn.type = 'button';
  topBtn.className = 'hp-top-btn';
  topBtn.setAttribute('aria-label', '回到頂部');
  topBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V6M6 11l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(topBtn);

  var topTicking = false;
  function updateTopBtn() {
    topBtn.classList.toggle('is-visible', window.scrollY > 300);
    topTicking = false;
  }
  window.addEventListener('scroll', function () {
    if (!topTicking) {
      window.requestAnimationFrame(updateTopBtn);
      topTicking = true;
    }
  }, { passive: true });
  topBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  updateTopBtn();

  /* ─── 4. Lazy image fade-in ─── */
  document.querySelectorAll('.hp-xm img[loading="lazy"], .hp2 img[loading="lazy"]').forEach(function (img) {
    img.classList.add('hp-img-fade');
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    }
  });

  /* ─── 5. Ranking tab filter ─── */
  var tabBar = document.querySelector('[data-hp-rising-tabs]');
  if (tabBar) {
    tabBar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hp-tab]');
      if (!btn) return;
      tabBar.querySelectorAll('[data-hp-tab]').forEach(function (tab) {
        tab.classList.toggle('is-active', tab === btn);
      });
      var model = btn.getAttribute('data-hp-tab');
      document.querySelectorAll('.hp2-rising-card').forEach(function (card) {
        card.classList.toggle('is-filtered-out', model !== 'all' && card.getAttribute('data-model') !== model);
      });
    });
  }
})();
